// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/HgCeD" + chunkId + "z8b8ImbFLN.css";
};